import React, { createContext, useContext } from 'react';

const LocationContext = createContext(null);

export const LocationProvider = ({ value, children }) => (
  <LocationContext.Provider value={value}>
    {children}
  </LocationContext.Provider>
);

export const useSelectedLocation = () => useContext(LocationContext);

export default LocationContext;
